import styled from "styled-components";

export const PasoDatosDeRetiroComponent = styled.div`
  p {
    margin-bottom: 0;
  }
`;
